module.exports = __webpack_public_path__ + "static/media/arrow_right-24px.003666b2.svg";